import {
  getAllFreightCommodityIdEffect,
  getBranchesByCustomerEffect,
  getRentalCompaniesEffect,
  getUnitSizesEffect,
} from '@/redux/Savers/SaversEffects';
import { useEffect, useState } from 'react';

const useDropdownState = (companyId) => {
  const [dropdownState, setDropdownState] = useState({
    commodityOptions: [],
    partnerLocationOptions: [],
    unitSizeOptions: [],
    rentalCompanyOptions: [],
    loading: {
      commodities: false,
      partnerLocations: false,
      unitSize: false,
      rentalCompany: false,
    },
  });

  const getTrailerCommodities = async () => {
    setDropdownState((prev) => ({ ...prev, loading: { ...prev.loading, commodities: true } }));

    try {
      const { data } = await getAllFreightCommodityIdEffect();

      const options = data.map((row) => ({
        label: row.freightCommodity,
        value: row.freightCommodityID,
      }));

      setDropdownState((prev) => ({
        ...prev,
        commodityOptions: options,
        loading: { ...prev.loading, commodities: false },
      }));
    } catch (error) {
      console.log('error', error);

      setDropdownState((prev) => ({
        ...prev,
        commodityOptions: [],
        loading: { ...prev.loading, commodities: false },
      }));
    }
  };

  const getPartnerLocations = async (companyId) => {
    setDropdownState((prev) => ({ ...prev, loading: { ...prev.loading, partnerLocations: true } }));
    try {
      if (!companyId || companyId === '0') {
        setDropdownState((prev) => ({
          ...prev,
          partnerLocationOptions: [],
          loading: { ...prev.loading, partnerLocations: false },
        }));
        return;
      }
      // TODO: useGetShipmentVendorBranch hook
      const { data } = await getBranchesByCustomerEffect(companyId);

      const options = data.map((row) => ({
        label: row.branchDesc,
        value: row.branchKey,
        entityCode: row.entityCode,
      }));

      setDropdownState((prev) => ({
        ...prev,
        partnerLocationOptions: options,
        loading: { ...prev.loading, partnerLocations: false },
      }));
    } catch (error) {
      console.log('error', error);

      setDropdownState((prev) => ({
        ...prev,
        partnerLocationOptions: [],
        loading: { ...prev.loading, partnerLocations: false },
      }));
    }
  };

  const getUnitSizes = async () => {
    setDropdownState((prev) => ({ ...prev, loading: { ...prev.loading, unitSize: true } }));
    try {
      const { data } = await getUnitSizesEffect();

      const options = data.map((row) => ({
        label: row.size,
        value: row.id,
      }));

      setDropdownState((prev) => ({
        ...prev,
        unitSizeOptions: options,
        loading: { ...prev.loading, unitSize: false },
      }));
    } catch (error) {
      console.log('error', error);

      setDropdownState((prev) => ({
        ...prev,
        unitSizeOptions: [],
        loading: { ...prev.loading, unitSize: false },
      }));
    }
  };

  const getRentalCompanies = async () => {
    setDropdownState((prev) => ({ ...prev, loading: { ...prev.loading, rentalCompany: true } }));
    try {
      const { data } = await getRentalCompaniesEffect();

      const options = data.map((row) => ({
        label: row.name,
        value: row.id,
      }));

      setDropdownState((prev) => ({
        ...prev,
        rentalCompanyOptions: options,
        loading: { ...prev.loading, rentalCompany: false },
      }));
    } catch (error) {
      console.log('error', error);

      setDropdownState((prev) => ({
        ...prev,
        rentalCompanyOptions: [],
        loading: { ...prev.loading, rentalCompany: false },
      }));
    }
  };

  useEffect(() => {
    getTrailerCommodities();
    getUnitSizes();
    getRentalCompanies();
  }, []);

  useEffect(() => {
    getPartnerLocations(companyId);
  }, [companyId]);

  return dropdownState;
};

export default useDropdownState;
